import baseApi from "@/helpers/baseApi";

const postCustomEvent = (eventName, requestOptions) => {
    return baseApi.post(`/api/custom_event/${eventName}`, requestOptions)
}

export { postCustomEvent };